import { FileText, ClipboardCheck, MessagesSquare } from "lucide-react";
import { Chapter, Reveal } from "./Reveal";
import { METHOD_STEPS } from "../../data/content";

export const Method = () => (
    <section id="method" data-testid="method-section" className="py-28 md:py-40 bg-ink text-bone">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
            <Reveal className="mb-12 md:mb-16">
                <div className="flex items-baseline gap-4 mb-4">
                    <span className="font-mono text-xs tracking-widest text-oxblood">Ch. 06</span>
                    <span className="font-mono text-xs uppercase tracking-[0.25em] text-bone/50">
                        How sessions work
                    </span>
                </div>
                <h2
                    data-testid="method-heading"
                    className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05]"
                >
                    Every session has
                    <br />
                    <em className="text-bone/60">a purpose.</em>
                </h2>
            </Reveal>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-bone/10">
                {METHOD_STEPS.map((s, i) => (
                    <Reveal key={s.n} delay={i * 0.08} className="bg-ink">
                        <div data-testid={`method-step-${s.n}`} className="p-8 h-full group">
                            <span className="font-serif italic text-4xl text-bone/25 group-hover:text-oxblood transition-colors duration-500">
                                {s.n}
                            </span>
                            <h3 className="font-serif text-xl mt-6 mb-3">{s.title}</h3>
                            <p className="text-bone/60 text-sm leading-relaxed">{s.body}</p>
                        </div>
                    </Reveal>
                ))}
            </div>

            <div className="mt-20 grid md:grid-cols-3 gap-px bg-bone/10">
                {[
                    {
                        icon: ClipboardCheck,
                        title: "Homework where it helps",
                        body: "Additional practice may be provided after a session where appropriate, based on the student's needs, workload and areas requiring further development.",
                        id: "homework",
                    },
                    {
                        icon: MessagesSquare,
                        title: "Updates for parents",
                        body: "Where a parent is available at the end of a session, the tutor provides a brief verbal summary of work covered and progress — and parents are welcome to ask for updates anytime.",
                        id: "updates",
                    },
                    {
                        icon: FileText,
                        title: "Written progress reports",
                        body: "After every 10 sessions, a written report is prepared and sent to parents — outlining progress, strengths, areas for improvement and recommendations for future sessions.",
                        id: "reports",
                    },
                ].map((f, i) => (
                    <Reveal key={f.id} delay={i * 0.08} className="bg-ink">
                        <div data-testid={`progress-feature-${f.id}`} className="p-8 h-full">
                            <f.icon className="w-5 h-5 text-oxblood" strokeWidth={1.5} />
                            <h3 className="font-serif text-lg mt-4 mb-2">{f.title}</h3>
                            <p className="text-bone/60 text-sm leading-relaxed">{f.body}</p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
